import { render } from "./prePrint.vue?vue&type=template&id=17592492"
import script from "./prePrint.vue?vue&type=script&lang=js"
export * from "./prePrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__